import 'babel-polyfill';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import axios from 'axios';
import ReservationList from '../components/ReservationList'
import './style/App.css';

moment.locale('it');

class App extends React.Component {
    static propTypes = {
    }
    state = {
        config: null
    }
    componentDidMount() {
        axios.get('config.json').then(response => {
            if(typeof response.data !== 'object') {
                console.warn("Broken configuration file");
            } else {
                this.setState({config: response.data});
            }
        }).catch(e => {});
    }
    render() {
        if(!this.state.config) {
            return null;
        }
        return (
            <ReservationList config={this.state.config} />
        );
    }
}

export default App;
